<template>
    <div>
        <div class="row">
            <div class="col-12" style="padding-right: 5px;padding-left: 5px;">
                <!-- {{review}} {{question.attempted}} -->
                <div class="alert alert-danger" role="alert" v-if="review && question.attempted == false">
                    <b>Not Attempted!!</b>
                </div>
            </div>
        </div>
        <div class="row px-4" v-if="question">
            <div class="col-md-6">
                <div class="question-text">
                    <!-- <p v-if="review && question.attempted == false">Not Attempted!!</p> -->
                     <p><span>{{index+1}})</span> {{question.question}}</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="mcqdiv">
                <div class="answerdiv" v-if="!review">
                    <div class="row" v-for="(option, i) in question.options" :key="option.optionId">
                        <div class="col-sm-2">
                            <span class="ans_sr_no">{{i+1}}</span>
                        </div>
                        <div class="col-sm-10">
                            <p class="ans_text" :class="{active:option.optionId == selected}" @click="getAnswer(option.optionId, question.id)">{{option.option}}</p>
                        </div>
                    </div>
                </div>
                <div class="answerdiv" v-else>
                    <div class="row" v-for="(option, i) in question.options" :key="option.optionId">
                        <div class="col-sm-2">
                            <span class="ans_sr_no">{{i+1}}</span>
                        </div>
                        <div class="col-sm-10">
                            <p class="ans_text" :class="option.styleClass">{{option.option}}</p>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['questionObj', 'review', 'index'],
    data(){
      return {
         question: this.questionObj,
         selected: undefined,
         active: {
            'background-color': '#50abc9',
            'color': '#fff',
            'border': '1px solid #50abc9'
         },
         wrong: {
            'background-color': '#f44336',
            'color': '#fff',
            'border': '1px solid #f44336'
        },
        isActive: false
      }
    },
    methods:{
        getAnswer(oId,qId){
            this.selected = oId
            this.isActive = true
            this.$emit('answer', {questionId: qId, optionId: oId})
        }
    },
    watch:{
        questionObj(newVal){
            this.question = newVal
        }
    }
}
</script>
<style scoped>
.active {
    background-color: #50abc9;
    color: #fff;
    border: 1px solid #50abc9;
}
.wrong {
    background-color: #f44336;
    color: #fff;
    border: 1px solid #f44336;
}
</style>
